var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageheader",style:({ backgroundImage: 'url(' + _vm.image + ')' })},[_c('b-link',{attrs:{"to":"/"}},[_c('b-img',{staticClass:"logoimage",attrs:{"src":_vm.$imagestore1+'/logo/logo-15jaar-noback-shadows.png'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }